import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAfterTideAuth } from '../../context/AfterTideAuthContext';
import { AfterTideHeader } from './AfterTideHeader';
import Footer from '../Layout/Footer';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface AfterTideLayoutProps {
  children: React.ReactNode;
}
export const AfterTideLayout: React.FC<AfterTideLayoutProps> = ({
  children
}) => {
  const {
    isVerified
  } = useAfterTideAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  useEffect(() => {
    if (!isVerified && location.pathname !== '/aftertide/verify') {
      navigate('/aftertide/verify', {
        replace: true
      });
    }
  }, [isVerified, navigate, location.pathname]);
  if (!isVerified && location.pathname !== '/aftertide/verify') {
    return <div className={`min-h-screen ${dk.page}`} data-id="element-823" data-mp="1dvz5j2njlf5q" />;
  }
  return <div className={`min-h-screen flex flex-col aftertide-fonts ${dk.page} ${dk.textPrimary} selection:bg-[#c77dba] selection:text-[#1a1a2e]`} data-id="element-824" data-mp="1n5p4jcxz4ryl">
      <AfterTideHeader data-id="element-825" data-mp="1e3xy25vm0h3o" />
      <main className="flex-grow" data-id="element-826" data-mp="1e360ipigc9ar">{children}</main>
      <Footer data-id="element-827" data-mp="1e61yuey7ozzq" />
    </div>;
};